import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="#FFF9E8" d="M0 0h120v120H0z" /><path d="M52 64c-6 4-8 4-12 5s-4 7-4 14c0 5.6 16 6 24 6m8-25c6 4 8 4 12 5s4 7 4 14c0 5.6-16 6-24 6M48 45c0-11 6-14 12-14s12 3 12 14-7 16-12 16-12-5-12-16z" stroke="#FCC11B" strokeWidth="3" /></svg>);